import { TFunction } from 'i18next'

import { getFormattedBalance } from '../../../../elements/BalanceCell/utils/getFormattedBalance'
import { PeriodValue } from '../../../../types/inputTypes'
import { GenericTableRow } from '../../../../utils/buildTableData'
import { ProfitAndLossColumn } from '../constants/columnConfiguration'
import { ProfitAndLossTableBalance } from '../types/tableTypes'

export const getHeaderRow = (periods: PeriodValue[], columnsPerPeriod: number): string[] => [
  '', // First empty cell for the row
  ...periods.flatMap((period) => [period.label, ...Array(columnsPerPeriod - 1).fill('')]),
]

export const getSubHeaderRow = (
  periods: PeriodValue[],
  visibleColumns: ProfitAndLossColumn[],
  t: TFunction,
): string[] => [
  '', // First empty cell for the row
  ...periods.flatMap(() => visibleColumns.map((column) => t(column.label))),
]

export const getRowData = (
  row: GenericTableRow<ProfitAndLossTableBalance>,
  periods: PeriodValue[],
  visibleColumns: ProfitAndLossColumn[],
): string[] => [
  row.label,
  ...periods.flatMap((period) => {
    const periodBalance = row.balances.find((balance) => balance.period === period.key)?.balance

    return visibleColumns.map((column) => {
      const value = periodBalance?.[column.key] ?? 0
      const isRelative = ['percentageChange', 'percentageOfType'].includes(column.key)
      return getFormattedBalance(value, isRelative)
    })
  }),
]
